import { supabase } from './supabase';

export interface ServerGenerationAccess {
  allowed: boolean;
  tier: 'FREE' | 'PREMIUM';
  generationTier: 'FREE' | 'PREMIUM';
  advertisementEligible: boolean;
  planCode: string;
  planName: string;
  periodType: 'calendar_month' | 'billing_month' | 'term' | 'sast_day';
  periodUsed: number;
  periodLimit: number;
  remainingVideos: number;
  unlimited?: boolean;
  periodStartedAt: string;
  periodResetAt: string;
  dailyUsed: number;
  monthlyUsed: number;
  dailyLimit: number;
  monthlyLimit: number;
  dailyResetAt: string;
  monthlyResetAt: string;
}

export async function fetchGenerationAccess(): Promise<ServerGenerationAccess> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  const response = await fetch('/api/generation/access', {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    cache: 'no-store',
  });
  const payload = await response.json();
  if (!response.ok) throw new Error(payload.error || 'Generation access could not be verified.');
  if (!['FREE', 'PREMIUM'].includes(payload.tier) ||
      !Number.isInteger(payload.periodLimit) || !Number.isInteger(payload.periodUsed) ||
      !Number.isInteger(payload.remainingVideos) ||
      (payload.unlimited !== undefined && typeof payload.unlimited !== 'boolean') ||
      payload.remainingVideos !== Math.max(0, payload.periodLimit - payload.periodUsed)) {
    throw new Error('Invalid server generation access.');
  }
  return payload;
}